export default __webpack_public_path__ + "static/media/phone_red.a666dbed.svg";